import { render, staticRenderFns } from "./SideCard.vue?vue&type=template&id=214957f0&"
import script from "./SideCard.vue?vue&type=script&lang=ts&"
export * from "./SideCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VDivider,VIcon,VSheet,VSlideXReverseTransition})
